import React, {useEffect} from 'react';
import {Helmet} from 'react-helmet';
import {loadCSS, removeCSS} from '../utils/useScript';
import '../assets/font-awesome-4.7.0/css/font-awesome.min.css';
import redtie_logo from '../assets/img/redtie_logo.png';
import signup_success from '../assets/img/signup_success.png';

const SHUTDOWN_DATE = 'July 3rd';

export default function AppShutdown() {
  useEffect(() => {
    loadCSS('https://s3-us-west-1.amazonaws.com/files.redtie.co/reditev4/adminlte.min.css');
    loadCSS('https://s3-us-west-1.amazonaws.com/files.redtie.co/reditev4/signup_onboarding_style.css');
    return () => {
      removeCSS('https://s3-us-west-1.amazonaws.com/files.redtie.co/reditev4/adminlte.min.css');
      removeCSS('https://s3-us-west-1.amazonaws.com/files.redtie.co/reditev4/signup_onboarding_style.css');
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Redtie - Shutting Down {SHUTDOWN_DATE}</title>
      </Helmet>
      <div className="hold-transition new_signup_bodywrapper">
        <div className="wrapper">
          <div className="content-wrapper">
            <div className="container-fluid">
              <div className="new_signup_bodydiv">
                <div className="newlogo text-center pdngtop_10 pdngbtm_10 hidden visible-xs">
                  <img src={redtie_logo} alt="Redtie" title="Redtie" />
                </div>
                <div className="new_overall_signup_container">
                  <div className="new_overall_signup_bodydiv bg_white">
                    <div className="col-xs-12 col-sm-12 col-md-5 newsignup_bg brdrradius_lft">
                      <div className="new_signup_leftcontainer">
                        <div className="new_signup_titleicon text-center">
                          <img src={signup_success} alt="Service Discontinued" />
                        </div>
                        <div className="new_signup_title text-center">
                          <h1>Thank You for Being Part of Redtie</h1>
                        </div>
                      </div>
                    </div>

                    <div className="col-xs-12 col-sm-12 col-md-7">
                      <div className="new_signup_rightcontainer">
                        <div className="newlogo text-center pdngtop_10 pdngbtm_10 hidden-xs">
                          <img src={redtie_logo} alt="Redtie" title="Redtie" />
                        </div>

                        <div className="new_signup_innerdiv" style={{textAlign: 'center', padding: '10px 20px'}}>
                          <div
                            style={{
                              background: '#fff3cd',
                              border: '1px solid #ffc107',
                              borderRadius: '8px',
                              padding: '14px 18px',
                              marginBottom: '22px',
                            }}>
                            <i className="fa fa-exclamation-triangle" aria-hidden="true" style={{color: '#e65c00', fontSize: '22px', marginBottom: '6px'}} />
                            <p style={{margin: 0, fontWeight: 700, fontSize: '15px', color: '#7a4300'}}>
                              Important Notice
                            </p>
                          </div>

                          <h2 style={{fontSize: '20px', fontWeight: 700, color: '#333', marginBottom: '12px'}}>
                            Redtie is Shutting Down on {SHUTDOWN_DATE}
                          </h2>

                          <p style={{fontSize: '14px', color: '#555', lineHeight: '1.7', marginBottom: '16px'}}>
                            After years of serving thousands of businesses and individuals, we have made the
                            difficult decision to shut down Redtie on <strong>{SHUTDOWN_DATE}</strong>. We are deeply
                            grateful to every customer who trusted us with their communications.
                          </p>

                          <div
                            style={{
                              background: '#f8f9fa',
                              borderRadius: '8px',
                              padding: '14px 18px',
                              marginBottom: '20px',
                              textAlign: 'left',
                            }}>
                            <p style={{fontWeight: 700, fontSize: '13px', color: '#333', marginBottom: '10px'}}>
                              <i className="fa fa-info-circle" aria-hidden="true" style={{marginRight: '6px', color: '#c0392b'}} />
                              What this means for you:
                            </p>
                            <ul style={{paddingLeft: '18px', margin: 0, fontSize: '13px', color: '#555', lineHeight: '1.8'}}>
                              <li>All sign-in and sign-up access has been disabled.</li>
                              <li>No new charges will be made to your account.</li>
                              <li>Active subscriptions have been cancelled automatically.</li>
                            </ul>
                          </div>

                          <div
                            style={{
                              background: '#f0f7ff',
                              borderRadius: '8px',
                              padding: '14px 18px',
                              marginBottom: '20px',
                              textAlign: 'left',
                            }}>
                            <p style={{fontWeight: 700, fontSize: '13px', color: '#333', marginBottom: '8px'}}>
                              <i className="fa fa-envelope" aria-hidden="true" style={{marginRight: '6px', color: '#c0392b'}} />
                              Need help or have questions?
                            </p>
                            <p style={{fontSize: '13px', color: '#555', margin: 0, lineHeight: '1.7'}}>
                              Our support team is available to assist with data exports or billing enquiries.
                              Please reach out at{' '}
                              <a href="mailto:support@getredtie.com" style={{color: '#c0392b', fontWeight: 600}}>
                                support@getredtie.com
                              </a>
                            </p>
                          </div>

                          <p style={{fontSize: '13px', color: '#888', marginTop: '10px'}}>
                            We sincerely thank you for your support and loyalty over the years.
                            <br />
                            <strong style={{color: '#555'}}>— The Redtie Team</strong>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
